import React, { useState } from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';

const GHL_URL = (process.env.REACT_APP_GHL_EMAIL_BUILDER_URL || '').trim();

export function isGhlEmailBuilderConfigured() {
  return Boolean(GHL_URL);
}

/**
 * GoHighLevel email builder iframe. Parent should hide the tab when {@link isGhlEmailBuilderConfigured} is false.
 */
export default function GhlEmailBuilderFrame() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  return (
    <Box sx={{ position: 'relative', width: '100%', minHeight: 700 }}>
      {loading && (
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1 }}>
          <CircularProgress />
        </Box>
      )}
      <iframe
        src={GHL_URL}
        title="GoHighLevel Email Builder"
        width="100%"
        height={700}
        style={{ border: '1px solid #ddd', borderRadius: 4 }}
        allow="clipboard-write"
        onLoad={() => setLoading(false)}
        onError={() => {
          setLoading(false);
          setError(true);
        }}
      />
      {error && (
        <Alert severity="warning" sx={{ mt: 1 }}>
          Could not load GoHighLevel email builder. You may need to log into GoHighLevel first in another tab, then
          refresh this page.
        </Alert>
      )}
    </Box>
  );
}
